import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEcdConnectEmoji3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 177,
	height: 178,
	viewBox: "0 0 177 178",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M88.24 167.078C131.45 167.078 166.48 132.048 166.48 88.8381C166.48 45.6281 131.45 10.5981 88.24 10.5981C45.03 10.5981 10 45.6281 10 88.8381C10 132.048 45.03 167.078 88.24 167.078Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.52 70.5483C56.52 79.1483 49.54 86.1283 40.94 86.1283C32.34 86.1283 25.36 79.1483 25.36 70.5483C25.36 61.9483 32.34 54.9683 40.94 54.9683C49.54 54.9683 56.52 61.9383 56.52 70.5483Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.4799 64.5182C40.4799 67.0482 38.4299 69.0982 35.8999 69.0982C33.3699 69.0982 31.3199 67.0482 31.3199 64.5182C31.3199 61.9882 33.3699 59.9382 35.8999 59.9382C38.4299 59.9382 40.4799 61.9882 40.4799 64.5182Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.5 71.7381C45.5 73.1981 44.32 74.3781 42.86 74.3781C41.4 74.3781 40.22 73.1981 40.22 71.7381C40.22 70.2781 41.4 69.0981 42.86 69.0981C44.32 69.0981 45.5 70.2781 45.5 71.7381Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.12 70.5483C151.12 79.1483 144.15 86.1283 135.54 86.1283C126.93 86.1283 119.96 79.1483 119.96 70.5483C119.96 61.9483 126.93 54.9683 135.54 54.9683C144.15 54.9683 151.12 61.9383 151.12 70.5483Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.08 64.5182C135.08 67.0482 133.03 69.0982 130.5 69.0982C127.97 69.0982 125.92 67.0482 125.92 64.5182C125.92 61.9882 127.97 59.9382 130.5 59.9382C133.03 59.9382 135.08 61.9882 135.08 64.5182Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.1 71.7381C140.1 73.1981 138.92 74.3781 137.46 74.3781C136 74.3781 134.82 73.1981 134.82 71.7381C134.82 70.2781 136 69.0981 137.46 69.0981C138.92 69.0981 140.1 70.2781 140.1 71.7381Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.12 99.408C52.12 103.788 47.35 107.338 41.45 107.338C35.55 107.338 30.79 103.788 30.79 99.408C30.79 95.028 35.56 91.478 41.45 91.478C47.34 91.478 52.12 95.028 52.12 99.408Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.68 99.408C145.68 103.788 140.9 107.338 135.02 107.338C129.14 107.338 124.35 103.788 124.35 99.408C124.35 95.028 129.13 91.478 135.02 91.478C140.91 91.478 145.68 95.028 145.68 99.408Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.24 104.508C96.59 104.508 104.07 107.778 109.13 112.958C111.79 109.928 113.91 106.328 115.32 102.328C117.09 97.3081 114.02 91.7581 109.44 91.7581H67.03C62.46 91.7581 59.38 97.3081 61.16 102.328C62.57 106.318 64.69 109.928 67.35 112.958C72.41 107.788 79.89 104.508 88.24 104.508Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.24 122.698C96.44 122.698 103.85 118.958 109.13 112.948C104.07 107.778 96.59 104.508 88.24 104.508C79.89 104.508 72.41 107.778 67.35 112.948C72.63 118.958 80.03 122.698 88.24 122.698Z",
			fill: "#FF2180"
		})
	]
});
export default SvgEcdConnectEmoji3;
